module.exports = __webpack_public_path__ + "static/media/night_flight_1.df504bb2.jpg";